import { createRoot } from "react-dom/client";
import { createElement } from "react";
import { AppView } from "./AppContainer.fs.js";

createRoot(document.getElementById("logos-app")).render(createElement(AppView, null));

